


































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ATSJobListParams } from './models/jobs/atsjoblistparams';
import Header from './components/Header.vue';
import SideMenu from './components/SideMenu.vue';
import Searchbox from './components/Searchbox.vue';
import Joblisting from './components/Joblisting.vue';
import AppBanner from './components/AppBanner.vue';
import ReferFriendBox from './components/ReferFriendBox.vue';
import Banner from './components/Banner.vue';
import DashBanner from './components/DashBanner.vue';
import Signup from './components/Signup.vue';
import Login from './components/Login.vue';
import Findjobs from './components/Findjobs.vue';
import Verification from './components/Verification.vue';
import RetrieveOldEmailConfirmation from './components/Registration/RetrieveOldEmailConfirmation.vue';
import RetrievedEmailVerification from './components/Registration/RetrievedEmailVerification.vue';
import RetrievedEmailSignupPreference from './components/Registration/RetrievedEmailSignupPreference.vue';
import AppRetrieveOldEmailConfirmation from './components/Registration/AppRetrieveOldEmailConfirmation.vue';
import AppRetrievedEmailVerification from './components/Registration/AppRetrievedEmailVerification.vue';
import AppRetrievedEmailSignupPreference from './components/Registration/AppRetrievedEmailSignupPreference.vue';
import Invite from './components/Invite.vue';
import Jobdetails from './components/Jobdetails.vue';
import Referrals from './components/Referrals.vue';
import CandidatePortalLogo from './components/CandidatePortalLogo.vue';
import Footer from './components/Footer.vue';
import JobShare from './components/JobShare.vue';
import MobileAppBanner from '@/components/MobileAppBanner.vue';
import Loader from './components/Loader.vue';
import { vxm } from './store.vuex';
import axios from 'axios';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import router from '../router';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { UtmTrackerInfo } from './models/utility/utmtracker';
import { CandidatePortalClientCommonInfo } from './models/utility/lookup';
import { Company } from './models/company/companyprofile';
import DynamicContentComponent from './components/DynamicContent/DynamicContentComponent.vue';
import OrganizationJsonLD from './components/JsonLD/OrganizationJsonLD.vue';
import CompanyProfile from '@/components/CompanyProfile.vue';
import OnBoardingHeader from '@/components/EssiumIntegration/OnBoardingHeader.vue';
import TargetRecruitHeader from '@/components/TargetRecruitIntegration/TargetRecruitHeader.vue';
import { SIDE_MENU_ROUTE_MAPPER } from '@/models/configs/RoutersMap';
import {Rudderstack } from '@/models/utility/rudderstack'

Vue.component('vue-phone-number-input', VuePhoneNumberInput);

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});
declare var window: any;
@Component({
  name: 'App',
  components: {
    Header,
    DynamicContentComponent,
    OrganizationJsonLD,
    SideMenu,
    Searchbox,
    Joblisting,
    AppBanner,
    DashBanner,
    Banner,
    Signup,
    Login,
    JobShare,
    Findjobs,
    Verification,
    RetrieveOldEmailConfirmation,
    RetrievedEmailVerification,
    RetrievedEmailSignupPreference,
    AppRetrieveOldEmailConfirmation,
    AppRetrievedEmailVerification,
    AppRetrievedEmailSignupPreference,
    Invite,
    Jobdetails,
    Referrals,
    CandidatePortalLogo,
    Loader,
    ReferFriendBox,
    Footer,
    MobileAppBanner,
    CompanyProfile,
    OnBoardingHeader,
    TargetRecruitHeader,
  },
})
export default class App extends Vue {
  $wlToastr: any;
  private jobListParams: ATSJobListParams = new ATSJobListParams();
  private fullViewPage = this.isFullViewPage(this.thisURL);
  private showAppBanner: boolean = true;
  private showReferFriendBox: boolean = true;
  private CompanyInfo: Company = new Company();
  private userLang: string = 'en';

  hideAppBanner() {
    this.showAppBanner = false;
  }

  get canShowAppBanner() {
    return this.showAppBanner && this.$route.name !== 'WLReferralMain' && this.$route.name !== 'WLReferralMainSlug'
  }

  get canShowMobileAppBanner() {
    return !vxm.users.UserDeviceAppTkn && this.$route.name !== 'WLReferralMain';
  }
  @Watch('$route.name')
  onRouteChange(val) {
    this.fullViewPage = val && this.isFullViewPage(val);
  }

  get theme() {
    return vxm.utility.AppTheme;
  }
  get isCompanyProfileLandingPage() {
    return (
      vxm.configs.getGlobalConfigValue('LANDING_PAGE_BEFORE_SIGN_IN') === 'COMPANY_PROFILE' &&
      !this.isLoggedIn
    );
  }
  get supportedTranslationLanguages() {
    const langs = vxm.configs.getGlobalConfigValue('SUPPORTED_TRANSLATION_LANGUAGES');
    if(langs) return langs.split(',');
    return [];
  }
  constructor() {
    super();
    const vm = this;
    let parentResponse: any = null;
    let numberOfAPIs: any = [];
    axios.interceptors.request.use(
      (config) => {
        numberOfAPIs.push(1);
        parentResponse = config;
        let configUrl: string = '';
        configUrl = `${config.url}`;
        //Store the API details only if its not 'refreshtoken' API
        if (!configUrl.includes('refreshtoken')) {
          parentResponse = config;
        }
        vxm.utility.setSpinnerStatus(true);
        config.timeout = 90000; // 90 secs
        return config;
      },
      (error) => {
        vxm.utility.setSpinnerStatus(false);
        console.log('REQ', error);
        return Promise.reject(error);
      },
    );
    axios.interceptors.response.use(
      (response) => {
        numberOfAPIs.pop();
        vxm.utility.setSpinnerStatus(numberOfAPIs.length > 0);
        return response;
      },
      (error) => {
        if (error.code === 'ECONNABORTED') {
          this.$wlToastr(
            'error',
            this.$t('high-traffic-error'),
          );
          return;
        }
        numberOfAPIs.pop();
        vxm.utility.setSpinnerStatus(numberOfAPIs.length > 0);
        // -------------------------------------------------------------------------------
        // This condition is to keep working even while this new endpoint is not deployed for the environment (error 404)
        // Change the urls in the condition(remove if needed) if the endpoint url changes
        if (
          error.response.status === 404 &&
          error.response.data.path.includes(
            '/wl-jobs-svc/api/v4/jobfiltermetadatas/',
          )
        ) {
          console.log(
            error.response.data.path,
            'is not implemented for this environment. Error code: 404',
          );
          return;
        }
        // -------------------------------------------------------------------------------
        if (
          error.response.status === 401 &&
          parentResponse.url !== '/wl-sec-svc/api/auth/login' &&
          parentResponse.url !== '/wl-sec-svc/api/refreshtoken'
        ) {
          console.log('Access Token is expired, calling refresh token API');
          axios
            .get('/wl-sec-svc/api/refreshtoken', {
              headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + vxm.users.getRefreshToken,
              },
            })
            .then((response) => {
              console.log(
                'Obtained new set of Access/Refresh Token from refresh token API',
              );
              if (response.data.accessToken) {
                vxm.users.setToken(response.data.accessToken);
                vxm.users.setRefreshToken(response.data.refreshToken);
                vxm.users.setAuthStatus(true);
                parentResponse.headers.Authorization =
                  'Bearer ' + response.data.accessToken;
                axios(parentResponse);
              }
            })
            .catch((err) => {
              console.log('Refresh Token get err###' + err);
              if (err.response.status === 401) {
                vxm.users.setToken('');
                vxm.users.setRefreshToken('');
                vxm.users.setAuthStatus(false);
                vxm.users.sessionTimeout();
              }
            });
        }
        console.log('RES', error.response.data);
        console.log(error.response.status);
        console.log(error.response.statusText);
        console.log(error.response.headers);
        return Promise.reject(error);
      },
    );
  }
  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get companyCode() {
    return vxm.jobs.BrandingInfo.companycode;
  }

  get thisURL() {
    return window.location.href
      .split('/')
      [window.location.href.split('/').length - 1].replace('#', '');
  }

  get isEssiumIntegrationEnabled() {
    return (
    vxm.configs.subSectionEnabledInHomePage(
      'ONBOARDING',
      'ENABLE_ESSIUM_INTEGRATION',
    ) &&
      this.$route.path === '/onboarding'
    );
  }

  get isTargetRecruitTimesheetEnabled() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      const route = vxm.configs.ClientConfigs.slideMenuOptions.find(
        (route) =>
          SIDE_MENU_ROUTE_MAPPER[route.sectionKey] ===
          '/target-recruit-timesheet',
      );
      return route && this.$route.path === '/target-recruit-timesheet';
    }
    const route = vxm.jobs.BrandingInfo.leftMenu.slideMenuOptions.find(
      (item) => item.routerLink === '/target-recruit-timesheet',
    );
    return route && this.$route.path === '/target-recruit-timesheet';
  }

  get isExternalSystemPage() {
    return (
      this.isLoggedIn &&
      (this.isEssiumIntegrationEnabled || this.isTargetRecruitTimesheetEnabled)
    );
  }

  isFullViewPage(url) {
    url = url.search('/?') !== -1 ? url.split('?')[0] : url;
    return (
      [
        'login',
        'Login',
        'LoginUniversalEntryPoint',
        'LoginForm',
        'ForgotPasswordForm',
        'AccountLocked',
        'OTPLogin',
        'OTPLoginSuccess',
        'change-password',
        'ChangePasswordV2',
        'signup',
        'Signup',
        'JobShare',
        'forgot-password',
        'ForgotPassword',
        'troublelogin',
        'TroubleLogin',
        'anonverification',
        'AnonVerification',
        'RetrieveOldEmailConfirmation',
        'retrieveoldemailconfirmation',
        'RetrievedEmailVerification',
        'retrievedemailverification',
        'RetrievedEmailSignupPreference',
        'retrievedemailsignuppreference',
        'AppRetrieveOldEmailConfirmation',
        'Appretrieveoldemailconfirmation',
        'AppRetrievedEmailVerification',
        'Appretrievedemailverification',
        'AppRetrievedEmailSignupPreference',
        'appretrievedemailsignuppreference',
        'WLReferralMain',
        'GuidedSignup',
        'guidedsignup',
        'SkillCheckList',
        'skillchecklist',
        'GuidedSignupSkillCheckList',
        'guidedsignupskillchecklist',
        'appsignup',
        'AppSignup',
        'roleRegisterList',
        'RoleRegisterList',
        'engineerSignup',
        'EngineerSignup',
        'pilotSignup',
        'PilotSignup',
        'otherSignup',
        'OtherSignup',
        'otp-login',
      ].includes(url) ||
      !!window.location.pathname.match(/\/atsuser\/referral\/\w+/)
    );
  }

  public isHomepage() {
    // Default routing
    return this.$route.path === '/';
  }

  /*public isNotLoginOrSignUpPage() {
    if (vxm.utility.useLoginSignupV2) {
      let pageNames: Array<string> = [
        'LoginUniversalEntryPoint',
        'LoginForm',
        'ForgotPasswordForm',
        'AccountLocked',
        'OTPLogin',
        'OTPLoginSuccess',
        'ChangePasswordV2',
      ];
      let name: string = this.$route.name!;
      console.log(name);
      return !pageNames.includes(name);
    } else {
      return true;
    }
  }*/

  showOrganizationJsonLDContennt() {
    const routeAlias = this.$router.currentRoute.name;
    return (
      this.isHomepage() || 'Home' === routeAlias || 'Findjobs' === routeAlias
    );
  }

  beforeMount() {
    // let jwt =
    //   (this.$cookies && this.$cookies.get('jwtToken')) || window.WorkLLama.jwt;
    // if (jwt) {
    //   vxm.users.setToken(jwt);
    //   vxm.users.setAuthStatus(true);
    // }

    // Temporal otp token
    const jwtOtp = this.$cookies && this.$cookies.get('jwtOtpToken');
    if (jwtOtp) {
      vxm.users.setOtpToken(jwtOtp);
    }
    // Default lang
    const lang = this.$cookies && this.$cookies.get('userLang');
    if (lang) {
      vxm.users.setUserLang(lang);
    }
  }

  get favicon() {
    const brand = this.companyCode
      .replace(/DEV|QA|UAT|D2|DEMO2$/i, '')
      .toLowerCase();
    return `favicon-${brand}.ico`;

 
    
  }
  mounted() {
   
    Rudderstack.loadRudderAnalytics(window.WorkLLama.rudderStackKey ,window.WorkLLama.rudderStackUrl );
    window.document.addEventListener('wheel', function(event) {
      if (window.document.activeElement.type === 'number') {
        window.document.activeElement.blur();
      }
    });
    this.updateCompanyInfo();
    // let filterData = this.jobListParams;
    // vxm.jobs.reloadJobs(filterData);
    if (vxm.jobs.getCompanyCountryCode)
      this.$i18n.locale = vxm.jobs.getCompanyCountryCode.toLowerCase();
    const error = window.WorkLLama.errorMessage;
    if (error && !/<%=/.test(error)) {
      this.$router.push('/errormessage');
    }
    const tabIcon = <HTMLLinkElement>document.getElementById('fav-icon');
    tabIcon.href = `/atsuser/data/logo/${vxm.users.getCompanyCode}/CANDIDATEPORTAL/favicon.ico`;

    // Track UTM Parameters if any
    const queryParams = this.$route.query;
    const isTrackable = queryParams.hasOwnProperty('utm_source');
    console.log('isTrackable', isTrackable);
    if (isTrackable) {
      let utmTrackerInfo = new UtmTrackerInfo();
      utmTrackerInfo.setUtmParams(queryParams);
      utmTrackerInfo.companyCode = vxm.users.getCompanyCode;
      var basepath = window.location.pathname;
      var utm_deatils=window.location.href.split('?')[1]
      utmTrackerInfo.actionUrl = basepath + '?' + utm_deatils;
      if (basepath.includes('/jobdetails/')) {
        utmTrackerInfo.entity = 'Job';
        utmTrackerInfo.jobPostingId = parseInt(this.$route.params.JobID, 10);
      } else if (basepath.includes('/referral/')) {
        utmTrackerInfo.entity = 'Referral';
        utmTrackerInfo.referralCode = this.$route.params.referralCode;
      } else if (basepath.includes('/findjobs')) {
        utmTrackerInfo.entity = 'Jobs';
      } else {
        var pathParams = basepath.split('/');
        var basepathEntity = pathParams.pop();
        utmTrackerInfo.entity =
          basepathEntity == '' ? pathParams.pop() : basepathEntity;
      }
      console.log('TrackingEntity', utmTrackerInfo.entity);
      vxm.utmtracker.getUtmTrackerId(utmTrackerInfo);
    }

    // NPE condition: url includes "workingllama.com"
    // if the flag ADD_NOINDEX_TAG_TO_ALL_PAGES is set to true
    const host: string = window.location.host;
    if (
      host.includes('workingllama.com') || vxm.configs.getGlobalConfigValue('ADD_NOINDEX_TAG_TO_ALL_PAGES')
    ) {
      const metaTag: any = document.querySelector('meta[name="robots"]');
      metaTag.setAttribute('content', 'noindex');
    }
    this.userLang = vxm.users.getUserLang;
    const chatBubble:any = document.getElementById("chatBubble")
    if (chatBubble) {
      chatBubble.textContent = this.$t('bot.help.text');
    }
    const chatButton=document.getElementsByClassName("wl-chat-button")[0];
    if(chatButton){
    chatButton.addEventListener("click",()=>{
      vxm.users.Rudderstack.trackEvent("Chatbot Initiated", {})
    })
  }
    const panel = document.querySelector('.wl-sofi-panel');
    if (panel) {
  const observer = new MutationObserver(() => {
    const style = getComputedStyle(panel);

    if (style.display === 'none') {
      this.onPanelShow();
    }
  });

  observer.observe(panel, {
    attributes: true,
    attributeFilter: ['style', 'class']
  });
}
  }

  get appStoreUrlSection() {
    if (window.navigator.appVersion.indexOf('Android') !== -1) {
      return window.WorkLLama.workllamaAndroidAppUrl;
    }
    if (window.navigator.appVersion.indexOf('iPhone') !== -1) {
      return window.WorkLLama.workllamaIosAppUrl;
    }
    return '';
  }

  get appBodyStyle() {
    if (this.hasDynamicHeaderContent) {
      return {
        height: 'calc(100% - 222px) !important',
      };
    }
    return '';
  }

  get isDynamicHeaderInjectionEnabled() {
    return (
      this.hasDynamicHeaderContent &&  !(
        vxm.configs.getGlobalConfigBooelanValue('DYNAMIC_HEADER_WHEN_LOGGED_IN_ONLY') &&
        this.isLoggedIn
      )
    )
  }

  get hasDynamicHeaderContent() {
    if(vxm.configs.getGlobalConfigValue('DISPLAY_HEADER_FROM_CMS') && 
  vxm.configs.getGlobalConfigValue('ENABLE_DYNAMIC_HEADER_INJECTION')
  ) 
    return true
    const showHtml = vxm.configs.getGlobalConfigValue('HEADER_HTML') ? true : false
    if(vxm.configs.IsConfigJSONEnabled){
      return showHtml;
    } else {
      return vxm.configs.getGlobalConfigValue('ENABLE_DYNAMIC_HEADER_INJECTION') && showHtml;
    }
  }

  get hasDynamicFooterContent() {
    const showHtml = vxm.configs.getGlobalConfigValue('FOOTER_HTML') ? true : false
    if(vxm.configs.IsConfigJSONEnabled){
      return showHtml;
    } else {
      return vxm.configs.getGlobalConfigValue('ENABLE_DYNAMIC_FOOTER_INJECTION') && showHtml;
    }
  }

  get dynamicHeaderContent() {
    return vxm.configs.getGlobalConfigValue('HEADER_HTML')
  }

  get dynamicFooterContent() {
    return vxm.configs.getGlobalConfigValue('FOOTER_HTML')
  }

  get launchLogin() {
    return (
      vxm.configs.getGlobalConfigValue('LANDING_PAGE_BEFORE_SIGN_IN') === 'SIGNIN' &&
      !vxm.users.isLoggedIn
    );
  }

  // Get the company info from the server;
  updateCompanyInfo() {
    const payload = new CandidatePortalClientCommonInfo();
    payload.radius = vxm.jobs.FilterRadius;
    payload.latitude = vxm.jobs.latitude;
    payload.longitude = vxm.jobs.longitude;
    payload.companyCode = vxm.jobs.BrandingInfo.companycode;
    vxm.jobs.getCompanyInfo(payload).then((companyInfo) => {
      this.CompanyInfo = companyInfo;
    });
  }
  onPanelShow(){
      vxm.users.Rudderstack.trackEvent("Chatbot Closed", {})
  }
}
